/**
 * @generated SignedSource<<78d8c3949e5d69af896eaef955304cef>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type usePdpEstimateSimilarSoldTest_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useShowPricingGuidance_item">;
  readonly " $fragmentType": "usePdpEstimateSimilarSoldTest_item";
};
export type usePdpEstimateSimilarSoldTest_item$key = {
  readonly " $data"?: usePdpEstimateSimilarSoldTest_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"usePdpEstimateSimilarSoldTest_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "usePdpEstimateSimilarSoldTest_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useShowPricingGuidance_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "960d6c2b83f15745b7158cd9f393bbd4";

export default node;
